import { useLocation } from "react-router-dom";
import { Phone } from "lucide-react";

/**
 * Floating "Appelez-nous" button shown on mobile only, on the public pages
 * that don't already have their own sticky mobile call CTA. The Pro and
 * Particulier ES landing pages (rendered by MarketingLanding) bring their
 * own bottom bar with a phone button — no need to double it there.
 *
 * Hidden on desktop (md+) where the header phone link is already visible,
 * and inside the authenticated app where it would clash with sidebars.
 */
const PUBLIC_MARKETING_PATHS = [
  "/",
  "/particulier",
  "/not-eligible",
];

const PHONE_NUMBER = "+33756868432";

export default function MobileCallButton() {
  const { pathname } = useLocation();
  const isPublicPage = PUBLIC_MARKETING_PATHS.includes(pathname);
  if (!isPublicPage) return null;
  return (
    <a
      href={`tel:${PHONE_NUMBER}`}
      aria-label="Appelez-nous au 07 56 86 84 32"
      data-testid="mobile-call-fab"
      className="md:hidden fixed bottom-5 right-5 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#00B8E4] text-white shadow-lg shadow-[#00B8E4]/40 hover:bg-[#00a5ce] active:scale-95 transition-all duration-200"
    >
      <Phone className="w-6 h-6" />
    </a>
  );
}
